import { DefaultRootState } from 'react-redux';

export const selectAnalyticsParams = ({ analyticsParams }: DefaultRootState) => ({
    hhtmFrom: analyticsParams?.hhtmFrom || '',
    hhtmSource: analyticsParams?.hhtmSource || '',
    hhtmFromLabel: (analyticsParams?.hhtmFromLabel || '') as string,
    hhtmSourceLabel: (analyticsParams?.hhtmSourceLabel || '') as string,
});
